import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack, Text } from '@chakra-ui/react';
export const CheckoutHeading = (props) => (_jsxs(HStack, { gap: 3, h: 8, children: [_jsx(props.Icon, {}), _jsx(Text, { fontSize: 24, fontWeight: 500, children: props.children })] }));
